import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Vill du addera något till ditt ärende?")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "alert alert-secondary mt-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", null, "Tack för ditt omdöme.", -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.feedback) = $event)),
            class: "form-control",
            rows: 3,
            placeholder: "Här kan du skriva extra information om ditt ärende som kan vara bra för oss att veta."
          }, null, 512), [
            [_vModelText, _ctx.feedback]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendFeedback())),
            class: "btn btn-outline",
            disabled: _ctx.feedback === ''
          }, " Skicka ", 8, _hoisted_7),
          (_ctx.feedbackSend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}